export enum TokenType {
    PROPRIETARY_DEPRECATED = "PROPRIETARY_DEPRECATED", // ERC721 non compatible
    PLAIN_ERC721 = "PLAIN_ERC721",
    ERC721_WITH_VOLUNTARY_ROYALTIES = "ERC721_WITH_VOLUNTARY_ROYALTIES",
    ERC721_WITH_BUY_OUT = "ERC721_WITH_BUY_OUT",
}
